import FooterContainer from './FooterContainer.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(
      config,
      'footerContainer',
      FooterContainer
    );
  },
};
